import React from 'react';
import { FormattedMessage } from 'react-intl';

import { routes } from '@/config';

import * as S from './logged-out-banner.styles';

type Props = {
  className?: string;
};

export const LoggedOutBanner: React.VFC<Props> = ({ className }) => (
  <S.ContentBanner noPadding className={className} display="inline">
    <S.BodyCopy noMargin size="medium">
      <FormattedMessage id="XJM_SIGNUP_TEXT" />
    </S.BodyCopy>

    <S.Button size="medium" variant="primary" href={`${routes.signup}?signup_channel=jobs_search`}>
      <FormattedMessage id="XJM_SIGNUP_NOW" />
    </S.Button>
  </S.ContentBanner>
);
